import React from 'react'
import { Icon } from 'antd'

function ScannedBatchTable(props) {
    const { listBatches, handleDeleteBatch } = props

    return (
        <table className='ScannedBatchTable w-100 table table-border '>
            <thead className="">
                <tr>
                    <th className='col-2'>Tên lô</th>
                    <th className='col-1'>SKU</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {!!listBatches && !!listBatches.length && listBatches.map((i, index) => (
                    <tr key={index}>
                        <td className='col-2'>{i.name}</td>
                        <td className='col-1'>{i.SKU} </td>
                        <td><Icon type="close" className='ml-5' onClick={() => handleDeleteBatch(i.id)} /></td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default ScannedBatchTable